export default function dmaDistanceCalculation(cLat, cLon, dma) {
    //const newLat = res => {return cLat;}
    console.log(cLat, cLon);
    const R = 6371; // km
    const dLat = toRad(cLat-dma.lat);
    const dLon = toRad(cLon-dma.lon);
    const lat1 = toRad(dma.lat);
    const lat2 = toRad(cLat);
  
        const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
          Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
        const d = R * c;
     //   console.log('distance ',d);
        return d;
      };
    function toRad(Value) 
    {
        return Value * Math.PI / 180;
    }